<div class="modal-header">
  <h4 class="modal-title pull-left">
    <span *ngIf="currentFlow === getAddUserFlow()">{{'Add user' | translate}}</span>
    <span *ngIf="currentFlow === getEditUserFlow()">{{'Edit user' | translate}}</span>
    - {{'customer selection' | translate}}
  </h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="customerByCustomerNumberModalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  <p>{{'Please search by customer number' | translate}}</p>

  <form [formGroup]="customerForm" class="ng" fxLayout="column" novalidate
        [ngStyle]="{'height': '192px'}" [ngStyle.xs]="{'height': '312px'}">

    <div *ngIf="loading" class="ajax_loading_wrapper">
      <div class="ajax_loading"></div>
    </div>

    <div class="form-group" fxLayout fxLayout.xs="column">
      <label class="control-label" fxFlex="30">
        {{'Customer number' | translate}} *
      </label>
      <div class="input-container" fxLayout="column" fxFlex>
        <input
          type="text"
          class="form-control"
          formControlName="customerNumber"
          maxlength="10"
          autocomplete="off"
          id="customerNumber" name="customerNumber">
        <div
          *ngIf="customerForm.controls['customerNumber'].errors && (customerForm.controls['customerNumber'].dirty || customerForm.controls['customerNumber'].touched)">
          <small [hidden]="!customerForm.controls['customerNumber'].errors.required" class="feedback">
            {{'Required' | translate}}.
          </small>
          <small [hidden]="!customerForm.controls['customerNumber'].errors.pattern" class="feedback">
            {{'Customer number must contain only numbers' | translate}}
          </small>
        </div>
        <div *ngIf="customerForm.controls['customerNumber'].value && customerForm.controls['customerNumber'].dirty">
          <small [hidden]="getValidCustomerNumber()" class="feedback">
            {{getErrorMessage() | translate}}
          </small>
        </div>
      </div>
    </div>

    <div *ngIf="getCurrentCustomer()" class="customer-detail-container" fxLayout="column">
      <div class="form-group" fxLayout fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{'Company name' | translate}}
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            type="text"
            class="form-control"
            formControlName="company"
            maxlength="50"
            id="company" name="company">
        </div>
      </div>

      <div class="form-group" fxLayout fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{'Target group' | translate}}
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            type="text"
            class="form-control"
            formControlName="targetGroup"
            maxlength="50"
            id="targetGroup" name="targetGroup">
        </div>
      </div>

      <div class="form-group" fxLayout fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{'Contact person' | translate}}
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            type="text"
            class="form-control"
            formControlName="contactPerson"
            maxlength="50"
            id="contactPerson" name="contactPerson">
        </div>
      </div>
    </div>

  </form>

</div>
<div class="modal-footer" fxLayout fxLayoutAlign="space-between center">
  <button type="button" class="btn btn-info" (click)="goToNextStep()" [ngStyle]="{'width': '100%'}"
          [disabled]="!getCurrentCustomer() || customerForm.invalid">
    {{'Next' | translate}}
  </button>
</div>
